import { render, staticRenderFns } from "./pedimiento.vue?vue&type=template&id=5504e8c8&"
import script from "./pedimiento.vue?vue&type=script&lang=js&"
export * from "./pedimiento.vue?vue&type=script&lang=js&"
import style0 from "./pedimiento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports